module.exports = __webpack_public_path__ + "static/img/qingmei_icon.5b92878.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/qingmei_icon.png
// module id = Avd1
// module chunks = 1